import { render, staticRenderFns } from "./QueryResult.vue?vue&type=template&id=49ed46a3&"
import script from "./QueryResult.vue?vue&type=script&lang=js&"
export * from "./QueryResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports